import {
  aggregationIntervalFromPeriod,
  calendarPresetFromAggregationInterval,
  mapIntervalFromEntities,
  type AggregationPreset,
  type AggregationPeriod,
} from "./period";
import type { DateValue } from "@internationalized/date";

export const baseAggregationPeriodPresets = ({
  timezone,
  groups,
  limit,
}: {
  timezone: string;
  groups: { startDate: number; endDate: number }[];
  limit: { from: Date; to: Date };
}) => {
  const presets = [];
  const intervals = mapIntervalFromEntities(groups);

  const cyclePreset = calendarPresetFromAggregationInterval({
    interval: aggregationIntervalFromPeriod({
      period: "CYCLE",
      timezone,
      intervals,
    }),
    timezone,
    period: "CYCLE",
  });
  presets.push(cyclePreset);

  if (intervals.length >= 2) {
    const cycle2Preset = calendarPresetFromAggregationInterval({
      interval: aggregationIntervalFromPeriod({
        period: "CYCLE_2",
        timezone,
        intervals,
      }),
      timezone,
      period: "CYCLE_2",
    });
    presets.push(cycle2Preset);
  }

  const P1MPreset = calendarPresetFromAggregationInterval({
    interval: aggregationIntervalFromPeriod({
      period: "P1M",
      timezone,
    }),
    timezone,
    period: "P1M",
  });
  presets.push(P1MPreset);

  const P3MPreset = calendarPresetFromAggregationInterval({
    interval: aggregationIntervalFromPeriod({
      period: "P3M",
      timezone,
    }),
    timezone,
    period: "P3M",
  });
  presets.push(P3MPreset);

  const P6MPreset = calendarPresetFromAggregationInterval({
    interval: aggregationIntervalFromPeriod({
      period: "P6M",
      timezone,
    }),
    timezone,
    period: "P6M",
  });
  presets.push(P6MPreset);

  const P1YPreset = calendarPresetFromAggregationInterval({
    interval: aggregationIntervalFromPeriod({
      period: "P1Y",
      timezone,
    }),
    timezone,
    period: "P1Y",
  });
  presets.push(P1YPreset);

  const ALLPreset = calendarPresetFromAggregationInterval({
    interval: aggregationIntervalFromPeriod({
      period: "ALL",
      timezone,
      limit,
    }),
    timezone,
    period: "ALL",
  });
  presets.push(ALLPreset);

  return presets satisfies AggregationPreset<DateValue, AggregationPeriod>[];
};

export const eventAggregationPeriodPresets = (params: {
  timezone: string;
  groups: { startDate: number; endDate: number }[];
  limit: { from: Date; to: Date };
}) => {
  const basePresets = baseAggregationPeriodPresets(params);
  return basePresets.filter(preset => preset.metadata?.id !== "ALL");
};
